var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"staff"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.exportTable}},[_vm._v("导出表格")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }